import androidx.compose.runtime.*
import androidx.compose.runtime.snapshots.SnapshotStateMap
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

// Sdílená tabulka hráči × hry pro zadávání skóre — používají ji tréninky i turnaje. Podporuje
// per-sloupec typ hry (přes ⚙ toggle), kompletní zápis (📝) a volitelný extra sloupec (např.
// umístění u turnaje) přes sloty headExtra/rowExtra. `defaultType` = typ sloupce, když není nastaven.

@Composable
fun ScoreEntryTable(
    profiles: List<SgProfileDto>,
    games: Int,
    showTypes: Boolean,
    gameTypes: SnapshotStateMap<Int, String>,
    defaultType: String,
    scores: SnapshotStateMap<String, String>,
    sheets: SnapshotStateMap<String, List<FrameDto>>,
    onOpenEditor: (key: String, type: String) -> Unit,
    headExtra: (@Composable () -> Unit)? = null,
    rowExtra: (@Composable (SgProfileDto) -> Unit)? = null,
) {
    Div(attrs = { classes("stats-table-wrap", "score-entry-wrap") }) {
        Table(attrs = { classes("score-table") }) {
            Thead {
                Tr {
                    Th { Text("Hráč") }
                    headExtra?.let { extra -> Th { extra() } }
                    for (g in 1..games) {
                        Th {
                            Div(attrs = { classes("game-head") }) {
                                Span(attrs = { classes("game-head-label") }) { Text("hra $g") }
                                if (showTypes) {
                                    Select(attrs = {
                                        classes("type-select")
                                        onChange { ev -> ev.value?.let { gameTypes[g] = it } }
                                    }) {
                                        BOWLING_TYPES.forEach { (code, label) ->
                                            Option(code, attrs = { if ((gameTypes[g] ?: defaultType) == code) attr("selected", "selected") }) { Text(label) }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            Tbody {
                profiles.forEach { p ->
                    Tr {
                        Td { Text(p.displayName) }
                        rowExtra?.let { extra -> Td { extra(p) } }
                        for (g in 1..games) {
                            val k = "${p.blPlayerId}#$g"
                            val type = gameTypes[g] ?: defaultType
                            val hasSheet = sheets[k] != null
                            Td {
                                Div(attrs = { classes("score-cell") }) {
                                    Input(type = InputType.Text) {
                                        classes("score-input"); attr("inputmode", "numeric")
                                        if (hasSheet) attr("readonly", "readonly")
                                        value(scores[k] ?: "")
                                        onInput { if (!hasSheet) scores[k] = it.value }
                                    }
                                    Button(attrs = {
                                        classes(*(listOfNotNull("sheet-btn", "sheet-btn-on".takeIf { hasSheet }).toTypedArray()))
                                        attr("title", "Kompletní zápis"); attr("aria-label", "Kompletní zápis")
                                        onClick { onOpenEditor(k, type) }
                                    }) { Text("📝") }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
